/**
 * Root reducer.
 * @module reducers/root
 */


/**
 * Root reducer.
 * @function
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */

import { maintenanceModeReducer } from "./maintenanceModeReducer";
const reducers = {
    maintenanceMode: maintenanceModeReducer,
};

export default reducers;
